/**
 * Basecamp due-date calendar math.
 *
 * Hop org cache and crawl use America/Los_Angeles (see scripts/services/basecamp/org-overdue-query.js).
 * Do not use UTC `toISOString().slice(0, 10)` - after evening Pacific that is already tomorrow.
 *
 * Canonical:
 * - overdue = due_on < today
 * - due today = due_on === today
 * - overdue + due today = due_on <= today (PHP isDueOnOrBefore / crawl late bucket)
 */

export const BASECAMP_ORG_TIMEZONE = 'America/Los_Angeles'

export function todayInLosAngeles(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: BASECAMP_ORG_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now)
}

export function dueOnYmd(dueOn: string | null | undefined): string | null {
  if (!dueOn) return null
  const d = String(dueOn).slice(0, 10)
  return /^\d{4}-\d{2}-\d{2}$/.test(d) ? d : null
}

export function isBasecampDueToday(
  dueOn: string | null | undefined,
  today: string = todayInLosAngeles(),
): boolean {
  const d = dueOnYmd(dueOn)
  return !!d && d === today
}

/** Strict overdue: due before today. Does not include due today. */
export function isBasecampDueOverdue(
  dueOn: string | null | undefined,
  today: string = todayInLosAngeles(),
): boolean {
  const d = dueOnYmd(dueOn)
  return !!d && d < today
}

/** Combined late bucket (PHP isDueOnOrBefore). Overdue + due today. */
export function isBasecampDueOnOrBefore(
  dueOn: string | null | undefined,
  today: string = todayInLosAngeles(),
): boolean {
  const d = dueOnYmd(dueOn)
  return !!d && d <= today
}
